import React from "react";

const NoAddressesMessage = ({ type }) => {
  const message =
    type === "billing"
      ? "No billing addresses available."
      : "No shipping addresses available. Please add one.";

  return (
    <div className="flex items-center justify-center h-full py-20">
      <div className="bg-white shadow-lg rounded-lg p-6 text-center">
        <p className="text-gray-600 text-lg">{message}</p>
        {type === "shipping" && (
          <p className="text-gray-500 text-sm mt-2">
            Click the button below to add a new shipping address.
          </p>
        )}
      </div>
    </div>
  );
};

export default NoAddressesMessage;
